import { render, staticRenderFns } from "./SalesOrderViewInvoices.vue?vue&type=template&id=5bc1f3f0&scoped=true"
import script from "./SalesOrderViewInvoices.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewInvoices.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderViewInvoices.vue?vue&type=style&index=0&id=5bc1f3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1f3f0",
  null
  
)

export default component.exports